import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const MergeCustomerWrapper = ({ customerNames, customerEmail }) => {
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='<b>{customerNames}</b> share the email address {customerEmail}. Combining these customers may give a more comprehensive view of their order history.'
        description='Merge customer records alert'
        id='Q5VwAY'
        values={{
          customerNames,
          customerEmail,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    </React.Fragment>
  );
};

MergeCustomerWrapper.propTypes = {
  customerNames: PropTypes.string.isRequired,
  customerEmail: PropTypes.string.isRequired,
};

export const MergeCustomer = injectIntl(MergeCustomerWrapper);
